import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { HomePeriodDays } from '../homePeriod';
import { SocialBestPostCard } from './SocialBestPostCard';
import { socialBlockMessages as messages } from './socialBlockMessages';
import { SocialSummaryPost } from './socialSummaryTypes';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Social block; each part uses its own slice of it */
import styles from './SocialBlock.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialBestPostProps {
  post: SocialSummaryPost | null;
  days: HomePeriodDays;
  onOpenComposer: () => void;
}

/**
 * "Best post · last 28 days": the post with the most views of the period (design d1). With no
 * post it shows one sentence and the link "Open Composer" (design d2).
 */
const SocialBestPostComponent: React.FC<SocialBestPostProps> = ({ post, days, onOpenComposer }) => {
  const intl = useIntl();

  return (
    <div className={styles.column}>
      <div className={styles.key}>{intl.formatMessage(messages.bestPostPeriod, { days })}</div>
      {post === null ? (
        <div className={styles.best}>
          <div className={styles.bestText}>
            <p className={styles.bestEmpty}>{intl.formatMessage(messages.bestPostEmpty, { days })}</p>
            <button type="button" className={styles.rowAction} onClick={onOpenComposer}>
              {intl.formatMessage(messages.bestPostOpenComposer)}
            </button>
          </div>
        </div>
      ) : (
        <SocialBestPostCard post={post} />
      )}
    </div>
  );
};

export const SocialBestPost = TypedMemo(SocialBestPostComponent);
